import CrowdfundingShare, { I18N_CONTEXT } from './crowdfunding_share'
import { connect } from 'react-redux'
import { createRemotely } from 'redux/modules/campaign'
import { campaignUrlWithMeDomain } from 'lib/campaign_url'
import {
  getCampaignSelector,
  getLastCreatedCampaignSelector,
} from 'redux/selectors/campaign'
import preventNavigation from 'components/common/prevent_navigation'
import { formatMoney, formatDateShort } from 'client/griffin'
import { getCategoryLabel } from 'lib/category'
import { getI18n } from 'client/i18n'

const i18n = getI18n(I18N_CONTEXT)

const mapStateToProps = (state, props) => {
  const lastCreatedCampaign = getLastCreatedCampaignSelector(state)
  const campaign = lastCreatedCampaign || getCampaignSelector(state, props)
  const campaignId = campaign.id
  const urlWithMeDomain = campaignUrlWithMeDomain(campaign.id)
  const shareDescription = i18n('share_message', {
    goalAmount: formatMoney(campaign.currency, campaign.goal),
    expiryDate: formatDateShort(campaign.end_date),
    shareUrl: urlWithMeDomain,
    categoryName: getCategoryLabel(state, campaign.category).toLowerCase(),
  }).props.children

  return {
    campaignId,
    operatingRemotely: campaign.operatingRemotely,
    poolUrl: urlWithMeDomain,
    creationError: campaign.err,
    shareDescription,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onPublish() {
      dispatch(createRemotely(campaignId))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(preventNavigation(CrowdfundingShare, props => props.operatingRemotely))
